import {useState, useEffect} from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Context for user authentication
import { AuthContext } from '../contexts/AuthContext';

// React Router page components
import Home from '../pages/Home/Home';
import Search from '../pages/Search/Search';
import { default as SearchFr } from '../pages/Search/Search_fr';

// Bootstrap styles, optionally with jQuery and Popper
import 'bootstrap/dist/css/bootstrap.min.css';

// Custom app styles
import './App.css';
import '../assets/fonts/fonts.css';
import { default as SearchMRMR }  from '../pages/Search/Search_MRMR';
import SearchMagazine from '../pages/Search/Search_Magazine';
export default function App() {
  // React Hook: useState with a var name, set function, & default value
  const [user, setUser] = useState({});

  // Fetch authentication API & set user state
  async function fetchAuth() {
    const response = await fetch("/.auth/me");
    if (response) {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        response.json()
          .then(response => setUser(response))
          .catch(error => console.error('Error:', error));
      }
    }
  }

  // React Hook: useEffect when component changes
  // Empty array ensure this only runs once on mount
  useEffect(() => {
    fetchAuth()
  }, []);

  return (
    <AuthContext.Provider value={user}>
      <div className="container-fluid app">
        <BrowserRouter>
          <Routes>
            <Route path={`/`} element={<Home />} />
            <Route path={`/search`} element={<Search />} />
            <Route path={`/search-fr`} element={<SearchFr />} />
            <Route path={`/search-mrmr`} element={<SearchMRMR />} />
            <Route
              path="/search-magazine"
              element={<SearchMagazine isFrench={false} />}
            />

            <Route
              path="/search-magazine-fr"
              element={<SearchMagazine isFrench={true} />}
            />
            {/* <Route path={`*`} element={<Home />} /> */}
          </Routes>
        </BrowserRouter>
      </div>
    </AuthContext.Provider>
  );
}
